/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const transferManageRouter = {
  path: '/transferManage',
  component: Layout,
  hidden: false,
  alwaysShow: true,
  redirect: 'noredirect',
  name: 'transferManage',
  meta: {
    title: '转账管理',
    icon: 'menu-order',
    roles: ['merchant']
  },
  children: [
    {
      path: 'merchantTransfer',
      component: resolve => require(['@/views/merchant/transferManage/merchantTransfer'], resolve),
      name: 'MerchantTransfer',
      meta: { title: '商户转账', noCache: false }
    },
    {
      path: 'merchantTransferCheck',
      component: resolve => require(['@/views/merchant/transferManage/merchantTransferCheck'], resolve),
      name: 'MerchantTransferCheck',
      meta: { title: '转账查询', noCache: false }
    }
  ]
}

export default transferManageRouter



// WEBPACK FOOTER //
// ./src/router/merchant/transferManage.js